<template>
  <div class="wages wrapper shadow">
    <div class="operation">
      <div class="left">
        <div class="main-title">部门管理</div>
        <el-button
          type="primary"
          class="main-btn main-btn-primary"
          @click="addData"
          >添加</el-button
        >
        <el-button
          type="primary"
          class="main-btn main-btn-primary"
          @click="exportData"
          >导出</el-button
        >
        <el-button
          :type="selectStatus"
          class="main-btn"
          :class="{ 'main-btn-warning': selectStatus == 'warning' }"
          @click="batchDel"
          >批量删除</el-button
        >
      </div>
      <div class="right">
        <el-input
          class="search-input"
          v-model="query.keyword"
          placeholder="请输入查询关键字"
          clearable
        >
          <template #append>
            <div class="search-btn" @click="searchBtn">查询</div>
          </template>
        </el-input>
      </div>
    </div>
    <!-- 表格 -->
    <el-table
      header-row-class-name="main-table-header"
      :data="tableData"
      border
      height="670"
      @selection-change="handleSelectionChange"
      @row-dblclick="dbEdit"
    >
      <el-table-column type="selection" width="38" fixed />
      <el-table-column label="编码" min-width="90" fixed align="center">
        <template #default="scope">
          <el-input
            v-model="scope.row.code"
            :disabled="!scope.row.editStatus"
            placeholder="部门编码"
          />
        </template>
      </el-table-column>
      <el-table-column label="名称" min-width="90" fixed align="center">
        <template #default="scope">
          <el-input
            v-model="scope.row.name"
            :disabled="!scope.row.editStatus"
            placeholder="部门名称"
          />
        </template>
      </el-table-column>
      <el-table-column fixed="right" label="操作" width="135" align="center">
        <template #default="scope">
          <el-button
            type="primary"
            size="small"
            @click="editClick(scope.row)"
            v-if="!scope.row.editStatus"
            >编辑
          </el-button>
          <el-button
            type="primary"
            size="small"
            @click="saveClick(scope.row, scope.$index)"
            v-if="scope.row.editStatus"
            >保存</el-button
          >
          <el-button type="danger" size="small" @click="deleteRow(scope.$index)"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      background
      layout="prev, pager, next, total, sizes, jumper"
      :total="query.total"
      v-model:currentPage="query.page"
      v-model:page-size="query.pagesize"
      @size-change="getList"
      @current-change="getList"
      :page-sizes="[10, 20, 30, 40, 50, 100, 200, 500]"
    />
  </div>
</template>
<script setup>
import { ref } from "@vue/reactivity";
import { ElMessage, ElMessageBox } from "element-plus";
import { fetchList, save, batchUpdate } from "@/api/department";
import { onMounted } from "vue";

onMounted(() => {
  getList();
});

// 添加
const addData = () => {
  tableData.value.unshift({
    editStatus: true,
  });
};
//批量删除
const selectStatus = ref("info");
const batchDel = () => {
  if (SelectList.value.length == 0) {
    ElMessage.error("请至少选中一条信息！");
  } else {
    ElMessageBox.confirm("确定要删除所有选中信息吗?", "Warning", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      type: "warning",
    })
      .then(() => {
        batchUpdate({
          ids: SelectList.value.map((e) => e.id),
          field: "del",
          value: 1,
        }).then(() => {
          ElMessage.success("批量删除成功！");
          getList();
        });
      })
      .catch(() => {});
  }
};
//搜索
const query = ref({
  keyword: "",
  page: 1,
  pagesize: 15,
  total: "",
  sort: "+id",
});
const searchBtn = () => {
  getList();
};
// 表格
const tableData = ref([]);

const getList = () => {
  fetchList(query.value).then((res) => {
    tableData.value = res.data.list;
    query.value.total = res.data.total;
  });
};

// 表格编辑
const editClick = (row) => {
  row.editStatus = true;
};
// 表格双击编辑
const dbEdit = (row) => {
  row.editStatus = true;
};
const saveClick = (row, idx) => {
  if (!row.code) {
    ElMessage.error("请输入部门编码！");
    return;
  }
  if (!row.name) {
    ElMessage.error("请输入部门名称！");
    return;
  }
  ElMessageBox.confirm("确定要保存此行信息吗?", "Warning", {
    confirmButtonText: "确定",
    cancelButtonText: "取消",
    type: "warning",
  })
    .then(() => {
      save(row).then((res) => {
        tableData.value[idx] = res.data;
        tableData.value[idx].editStatus = false;
        ElMessage({
          type: "success",
          message: "保存成功！",
        });
      });
    })
    .catch(() => {
      // ElMessage({
      //   type: 'info',
      //   message: 'Delete canceled',
      // })
    });
};
const deleteRow = (index) => {
  ElMessageBox.confirm("确定要删除此行信息吗?", "Warning", {
    confirmButtonText: "确定",
    cancelButtonText: "取消",
    type: "warning",
  })
    .then(() => {
      batchUpdate({
        ids: [tableData.value[index].id],
        field: "del",
        value: 1,
      }).then(() => {
        getList();
        ElMessage({
          type: "success",
          message: "删除成功！",
        });
      });
    })
    .catch(() => {});
};
// 多选
const SelectList = ref([]);
const handleSelectionChange = (val) => {
  SelectList.value = val;
  console.log(SelectList.value.length);
  if (val.length > 0) {
    selectStatus.value = "warning";
  } else {
    selectStatus.value = "info";
  }
};

const exportData = () => {
  let _query = Object.assign({}, query.value);
  _query.page = 1;
  _query.pagesize = 9999;
  fetchList(_query).then((res) => {
    let list = res.data.list;
    import("@/vendor/Export2Excel").then((excel) => {
      const tHeader = ["部门编码", "部门名称"];
      const filterVal = ["code", "name"];
      const data = formatJson(filterVal, list);
      excel.export_json_to_excel({
        header: tHeader,
        data,
        filename: "部门信息",
        autoWidth: false,
        bookType: "xlsx",
      });
    });
  });
};

const formatJson = (filterVal, jsonData) => {
  return jsonData.map((v) =>
    filterVal.map((j) => {
      return v[j];
    })
  );
};
</script>
<style lang="scss" scoped>
::v-deep .el-table {
  .cell {
    padding: 0 5px;

    .el-input__wrapper {
      padding: 1px 5px;
    }
  }
}
</style>
